var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasMessage)?_c('div',{staticClass:"error-message",class:{
    'is-large': _vm.isLarge
  }},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }